import { getCsrfTokenFromCookie, getCsrfTokenFromUserCache } from "./utils/csrf.utils";
import { fetchAuthErrorInterceptor, fetchAuthErrorInterceptorServiceWorker } from "./interceptors/authentication.interceptor";

const fetchWithMethod =
  (
    method: "GET" | "POST" | "PUT" | "PATCH",
    getCsrfToken: () => Promise<string | null | undefined>,
    authErrorInterceptor: (response: Response) => Response
  ) =>
  (...args: Parameters<typeof fetch>): ReturnType<typeof fetch> =>
    getCsrfToken()
      .then((token) =>
        fetch(args[0], {
          method,
          headers: new Headers({ "Content-Type": "application/json", "X-XSRF-TOKEN": token ?? "EMPTY" }),
          ...args[1],
        })
      )
      .then((response) => {
        //only responses from the service worker fetch itself, you cannot intercept app errors here
        if (!response.ok) {
          return authErrorInterceptor(response);
        }
        return response;
      });

export const httpClient = {
  get: fetchWithMethod("GET", async () => getCsrfTokenFromCookie(), fetchAuthErrorInterceptor),
  post: fetchWithMethod("POST", async () => getCsrfTokenFromCookie(), fetchAuthErrorInterceptor),
  put: fetchWithMethod("PUT", async () => getCsrfTokenFromCookie(), fetchAuthErrorInterceptor),
  patch: fetchWithMethod("PATCH", async () => getCsrfTokenFromCookie(), fetchAuthErrorInterceptor),
};

export const httpClientServiceWorker = {
  get: (...args: Parameters<typeof fetch>) =>
    fetchWithMethod(
      "GET",
      getCsrfTokenFromUserCache,
      fetchAuthErrorInterceptorServiceWorker
    )(args[0], {
      credentials: "same-origin",
      ...args[1],
    }),
  post: (...args: Parameters<typeof fetch>) =>
    fetchWithMethod(
      "POST",
      getCsrfTokenFromUserCache,
      fetchAuthErrorInterceptorServiceWorker
    )(args[0], {
      credentials: "same-origin",
      ...args[1],
    }),
  put: (...args: Parameters<typeof fetch>) =>
    fetchWithMethod(
      "PUT",
      getCsrfTokenFromUserCache,
      fetchAuthErrorInterceptorServiceWorker
    )(args[0], {
      credentials: "same-origin",
      ...args[1],
    }),
  patch: (...args: Parameters<typeof fetch>) =>
    fetchWithMethod(
      "PATCH",
      getCsrfTokenFromUserCache,
      fetchAuthErrorInterceptorServiceWorker
    )(args[0], {
      credentials: "same-origin",
      ...args[1],
    }),
};
